import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SidepanelComponent } from './cs-sidepanel/sidepanel.component';
import {FormsModule} from "@angular/forms";
import {SidepanelOptions} from "@app/sidepanel/services/sidepanel-options";
import {ModalModule, TooltipModule} from "ngx-bootstrap";
import {SidepanelModalService} from "@app/sidepanel/services/sidepanel-modal.service";
import {TranslateModule} from '@ngx-translate/core';
import { PopupPanelComponent } from './cs-popup-panel/popup-panel.component';
import {CsModalBackdropComponent} from "@app/sidepanel/cs-backdrop/cs-modal-backdrop.component";
import { FullscreenModalService } from "@app/sidepanel/services/fullscreen-modal.service";
import { CsFullscreenPanelComponent } from './cs-fullscreen-panel/cs-fullscreen-panel.component';
import {CsMediumScreenPanelComponent} from "@app/sidepanel/cs-medium-screen-panel/cs-medium-screen-panel.component";
import {MediumScreenModalService} from "@app/sidepanel/services/medium-screen-modal.service";
import { MyScheduledActivitiesComponent} from "@app/sidepanel/my-scheduled-activities/my-scheduled-activities.component";
import { RouterModule } from '@angular/router';
import {CsComponentsModule} from "@app/shared/cs-components/cs-components.module";
import {CommunicationModalModule} from "@app/shared/communication-modals/communication-modal.module";
import {DirectivesModule} from "@app/directives";
import {ActivityAddTagModule} from "@app/shared/activity-add-tag/activity-add-tag.module";

@NgModule({
  declarations: [SidepanelComponent, PopupPanelComponent, CsModalBackdropComponent, CsFullscreenPanelComponent, CsMediumScreenPanelComponent,MyScheduledActivitiesComponent],
    imports: [
        FormsModule,
        CommonModule,
        TranslateModule,
        ModalModule.forRoot(),
        RouterModule,
        CsComponentsModule,
        TooltipModule,
        CommunicationModalModule,
        DirectivesModule,
        ActivityAddTagModule,
    ],
  providers: [
    SidepanelOptions,
    SidepanelModalService,
    FullscreenModalService,
    MediumScreenModalService
  ],
  entryComponents: [
    SidepanelComponent,
    PopupPanelComponent,
    CsModalBackdropComponent,
    CsFullscreenPanelComponent,
    CsMediumScreenPanelComponent,
    MyScheduledActivitiesComponent
  ],

})
export class SidepanelModule { }
